import Vue from 'vue';
import Vuex from 'vuex';
import TIM from 'tim-js-sdk';
import COS from "cos-js-sdk-v5";
import { Message } from 'element-ui'

Vue.use(Vuex);
//Shift+ I 首字母大写
//Shift+ U 转换为大写
//Shift+ L 转换为小写
const types = {
    SET_USER: 'SET_USER', // 用户登录信息
    SET_USER_PROFILE: 'SET_USER_PROFILE',// 用户完整信息
    SET_TARGET_USER: 'SET_TARGET_USER',
    SET_CURRENT_CHAT: 'SET_CURRENT_CHAT',
    SET_CURRENT_CONV: 'SET_CURRENT_CONV',
    SET_CURRENT_GROUP_MENBER: 'SET_CURRENT_GROUP_MENBER',
    RESET_CURRENT_CONV: 'RESET_CURRENT_CONV',
    SET_CONTACT_LIST: 'SET_CONTACT_LIST',
    SET_GROUP_LIST: 'SET_GROUP_LIST',
    SET_FRIEND_GROUP: 'SET_FRIEND_GROUP',
    SET_CONTACT_BOOK: 'SET_CONTACT_BOOK',
    SET_CONTACT_MAP: 'SET_CONTACT_MAP',
    SET_CONV_LIST: 'SET_CONV_LIST',
    SET_COMPANY_INFO: 'SET_COMPANY_INFO',
    SET_USER_PERMISSION: 'SET_USER_PERMISSION',
    RESET_CONV_LIST: 'RESET_CONV_LIST',
    SHOW_MESSAGE: 'SHOW_MESSAGE',
    PUSH_CURRENT_MESSAGE_LIST: 'PUSH_CURRENT_MESSAGE_LIST',
    GET_MESSAGE_LIST: 'GET_MESSAGE_LIST',
    CLEAR_CURRENT_UNREAD: 'CLEAR_CURRENT_UNREAD',
    PUSH_ADMIN_NOTICE: 'PUSH_ADMIN_NOTICE',
    PUSH_FRIEND_APPLY: 'PUSH_FRIEND_APPLY',
    PUSH_HANDLIAN_APPLY: 'PUSH_HANDLIAN_APPLY',
    PUSH_HAND_APPLY: 'PUSH_HAND_APPLY',
    PUSH_COPY_APPLY: 'PUSH_COPY_APPLY',
    DELETE_COPY_APPLY: 'DELETE_COPY_APPLY',
    DELETE_HAND_APPLY: 'DELETE_HAND_APPLY',
    PUSH_COMMENT_LIST: 'PUSH_COMMENT_LIST',
    PUSH_PHOTO_LIST: 'PUSH_PHOTO_LIST',
    USER_CENTER_SIGN: 'USER_CENTER_SIGN',
    FATHER_TREE_NOTE: 'FATHER_TREE_NOTE',
    SET_WAIT_MEMBER: 'SET_WAIT_MEMBER',
    LOAD_TREE_TIME: 'LOAD_TREE_TIME',
    VERSION_TREE_MAP: 'VERSION_TREE_MAP',
    PUSH_IMAGE_LIST: 'PUSH_IMAGE_LIST',
};

var options = {
    SDKAppID: 1400195688
};

var tim = TIM.create(options);

tim.setLogLevel(1);
// tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

tim.registerPlugin({ 'cos-js-sdk': COS });

window.tim = tim
window.TIM = TIM

Vue.prototype.tim = tim
Vue.prototype.TIM = TIM

const currentChatInfo = {
    selType: "",
    selToID: null,
    selToName: "",
    selToAvatar: "",
    sessionID: null,
};

const initUserSign = {
    feedPage: 1,
    articlePage: 1,
    albumPage: 1,
    audioPage: 1,
    videoPage: 1,
}

const initUserPermission = {
    articlePermission: 1,
    commentPermission: 1,
    musicPermission: 1,
    photoPermission: 1,
    sharePermission: 1,
    videoPermission: 1,
}

const initConversation = {
    messageList: [],
    type: "",
    userProfile: {
        avatar: "",
        userId: "",
        userName: "",
    },
    conversationID: "",
    nextReqMessageID: "",
    isCompleted: false,
    scrollBottom: true,
};


const chatType = {
    C2C: TIM.TYPES.CONV_C2C,
    GROUP: TIM.TYPES.CONV_GROUP,
    SYSTEM: TIM.TYPES.CONV_SYSTEM
};

const defaultAvatar = {
    C2C: 'http://148.70.221.198/pc/image/cl_user_avatar.png',
    GROUP: 'http://148.70.221.198/pc/image/cl_group_avatar.png',
    SYSTEM: 'http://148.70.221.198/pc/image/cl_admin_notice_50.png'
};

const initFriendGroup = ['朋友'];

const state = {
    user: {},
    userProfile: {},
    targetUser: {},
    defaultAvatar: defaultAvatar,
    chatType: chatType,
    timInstance: tim,
    timNamespace: TIM,
    currentChat: currentChatInfo,
    currentConversation: initConversation,
    contactMap: {},
    recentContacts: [],
    conversationList: [],
    currentMemberList: [],
    message: undefined,
    myContacts: [],
    myGroups: [],
    friendGroup: initFriendGroup,
    contactBook: [],
    adminNotice: [],
    handLianApply: [],
    copyTreeApply: [],
    commentList: [],
    photoUrlList: [],
    companyInfo: {},
    userCenterSign: initUserSign,
    userPermission: initUserPermission,
    fatherTreeNote: {},
    waitMemberMap: {},
    loadTreeTime: 0,
    versionTreeMap: {},
    imageUrlList: []
};

const getters = {
    user: state => {
        if (JSON.stringify(state.user) !== "{}") {
            return state.user
        } else {
            return JSON.parse(sessionStorage.getItem("userInfo"));
        }
    },
    userProfile: state => state.userProfile,
    targetUser: state => state.targetUser,
    defaultAvatar: state => state.defaultAvatar,
    recentContacts: state => state.recentContacts,
    contactsList: state => state.myContacts,
    friendGroup: state => state.friendGroup,
    contactBook: state => state.contactBook,
    conversationList: state => {
        return state.conversationList.filter(item => item.userId !== "admin");
    },
    friendsList: state => {
        return state.myContacts.filter(item => item.group == "朋友");
    },
    relativesList: state => {
        return state.myContacts.filter(item => item.group == "亲人");
    },
    workmatesList: state => {
        return state.myContacts.filter(item => item.group == "同事");
    },
    schoolmatesList: state => {
        return state.myContacts.filter(item => item.group == "同学");
    },
    currentChat: state => state.currentChat,
    currentConversation: state => state.currentConversation,
    croupsList: state => state.myGroups,
    currentMemberList: state => state.currentMemberList,
    adminNotice: state => {
        return state.adminNotice.sort(function (a, b) { return b.time - a.time })
    },
    handLianApply: state => state.handLianApply,
    copyTreeApply: state => {
        return state.copyTreeApply.sort(function (a, b) { return b.created_at - a.created_at })
    },
    commentList: state => state.commentList,
    imgUrlList: state => {
        return state.currentConversation.messageList
            .filter(message => message.type === TIM.TYPES.MSG_IMAGE && !message.isRevoked) // 筛选出没有撤回并且类型是图片类型的消息
            .map(message => message.payload.imageInfoArray[1].url)
    },
    photoUrlList: state => state.photoUrlList,
    companyInfo: state => state.companyInfo,
    userCenterSign: state => state.userCenterSign,
    userPermission: state => state.userPermission,
    fatherTreeNote: state => state.fatherTreeNote,
    waitMemberMap: state => state.waitMemberMap,
    loadTreeTime: state => state.loadTreeTime,
    versionTreeMap: state => state.versionTreeMap,
    imageUrlList: state => state.imageUrlList,
};

const mutations = {
    [types.SET_USER](state, user) {
        if (user) state.user = user;
        else state.user = {};
    },
    [types.SET_USER_PROFILE](state, data) {
        if (data) state.userProfile = data;
        else state.userProfile = {};
    },
    [types.SET_TARGET_USER](state, targetUser) {
        if (targetUser) state.targetUser = targetUser;
        else state.targetUser = {};
    },
    [types.SET_CURRENT_CHAT](state, chatInfo) {
        if (chatInfo) state.currentChat = chatInfo;
        else state.currentChat = currentChatInfo;
    },
    [types.SET_CURRENT_CONV](state, conversation) {
        if (conversation) state.currentConversation = conversation;
        else state.currentConversation = initConversation;
    },
    [types.RESET_CURRENT_CONV](state) {
        // state.currentConversation = initConversation; 
        Object.assign(state.currentConversation, initConversation);
    },
    [types.SET_CONTACT_LIST](state, contactList) {
        if (contactList) state.myContacts = contactList;
        else state.myContacts = [];
    },
    [types.SET_FRIEND_GROUP](state, friendGroup) {
        if (friendGroup) state.friendGroup = friendGroup;
        else state.friendGroup = initFriendGroup;
    },
    [types.SET_CONTACT_BOOK](state, contactBook) {
        if (contactBook) {
            state.contactBook = contactBook
        } else {
            state.contactBook = [];
            state.loadTreeTime = 0;
        }
    },
    [types.SET_GROUP_LIST](state, groupList) {
        if (groupList) state.myGroups = groupList;
        else state.myGroups = [];
    },
    [types.SET_CURRENT_GROUP_MENBER](state, menberList) {
        if (menberList) state.currentMemberList = menberList;
        else state.currentMemberList = [];
    },
    [types.SET_CONTACT_MAP](state, contactMap) {
        if (contactMap) state.contactMap = contactMap;
        else state.contactMap = {};
    },
    [types.SET_CONV_LIST](state, conversation) {
        if (conversation) state.conversationList = conversation;
        else state.conversationList = [];
    },
    [types.RESET_CONV_LIST](state) {
        state.conversationList = [];
        state.handLianApply = [];
        state.commentList = [];
        state.copyTreeApply = [];
    },
    [types.SHOW_MESSAGE](state, options) {
        if (state.message) {
            state.message.close()
        }
        state.message = Message({
            message: options.message,
            type: options.type || 'success',
            duration: options.duration || 2000,
            offset: 40
        })
    },
    [types.PUSH_CURRENT_MESSAGE_LIST](state, data) {
        // 还没当前会话，则跳过
        if (!state.currentConversation.conversationID) {
            return
        }
        if (Array.isArray(data)) {
            // 筛选出当前会话的消息
            const result = data.filter(item => item.conversationID === state.currentConversation.conversationID)
            state.currentConversation.messageList = [...state.currentConversation.messageList, ...result]
        } else if (data.conversationID === state.currentConversation.conversationID) {
            let oldMsg = state.currentConversation.messageList.filter(item => item.ID === data.ID);
            if (oldMsg.length == 0) {
                state.currentConversation.messageList = [...state.currentConversation.messageList, data]
            }
        }
    },
    [types.GET_MESSAGE_LIST](state, conversationID) {
        if (state.currentConversation.isCompleted) {
            context.commit('showMessage', {
                message: '已经没有更多的历史消息了哦',
                type: 'info'
            })
            return
        }
        const { nextReqMessageID, messageList } = state.currentConversation
        tim.getMessageList({ conversationID, nextReqMessageID, count: 15 }).then(imReponse => {
            // 更新messageID，续拉时要用到
            state.currentConversation.nextReqMessageID = imReponse.data.nextReqMessageID
            state.currentConversation.isCompleted = imReponse.data.isCompleted
            // 更新当前消息列表，从头部插入
            if (imReponse.data.messageList.length !== 0) {
                state.currentConversation.scrollBottom = false;
                state.currentConversation.messageList = [...imReponse.data.messageList, ...messageList]
            }
        })
    },
    [types.CLEAR_CURRENT_UNREAD](state, conversationID) {
        // let curConversation = state.conversationList.filter(item=>item.sessionId === conversationID);
        // if (curConversation.length!==0) {
        //     curConversation[0].unreadCount = 0;
        //     Object.assign(state.conversationList,curConversation);
        // }
        var findIndex = -1;
        state.conversationList.filter((item, index) => {
            if (item.sessionId == conversationID) {
                findIndex = index
            }
        });
        if (findIndex != -1) {
            state.conversationList[findIndex].unreadCount = 0
        }
    },
    [types.PUSH_ADMIN_NOTICE](state, data) {
        // 120 - 分组变化   
        // 168 - 强制退出消息
        // 502 - PC退出消息 
        // 502 - PC在线消息    
        // console.log(state.adminNotice);
        if (data) {
            var filterArr = ['120', '168', '500', '502'];
            for (let i in data) {
                if (filterArr.includes(data[i].type)) {
                    continue
                } else {
                    const result = state.adminNotice.filter(
                        item => item.time === data[i].time &&
                            item.type === data[i].type
                    );
                    if (result.length != 0) {
                        continue
                    }
                    state.adminNotice.push(data[i]);
                }
            }
        } else {
            state.adminNotice = []
        }
    },
    [types.PUSH_HAND_APPLY](state, data) {
        // if (data) {
        //     Object.assign(state.handLianApply,data);
        // }    
        if (data) {
            for (let i in data) {
                const result = state.handLianApply.filter(item => item.id === data[i].id);
                if (result.length != 0) {
                    continue
                }
                state.handLianApply.push(data[i]);
            }
        } else {
            state.handLianApply = []
        }
    },
    [types.PUSH_COPY_APPLY](state, data) {
        if (data) {
            // Object.assign(state.copyTreeApply,data);
            for (let i in data) {
                const findItem = state.copyTreeApply.filter(
                    item => item.id === data[i].id
                );
                if (findItem.length != 0) {
                    continue
                }
                state.copyTreeApply.push(data[i]);
            }
        } else {
            state.copyTreeApply = []
        }
    },
    [types.DELETE_COPY_APPLY](state, applyID) {
        if (applyID) {
            state.copyTreeApply = state.copyTreeApply.filter(item => item.id !== applyID);
        }
    },
    [types.DELETE_HAND_APPLY](state, applyID) {
        if (applyID) {
            state.handLianApply = state.handLianApply.filter(item => item.id !== applyID);
        }
    },
    [types.PUSH_COMMENT_LIST](state, data) {
        if (data) {
            Object.assign(state.commentList, data);
        }
    },
    [types.PUSH_PHOTO_LIST](state, data) {
        if (data) {
            state.photoUrlList = data
        }
    },
    [types.SET_COMPANY_INFO](state, data) {
        if (data) {
            state.companyInfo = data
        }
    },
    [types.USER_CENTER_SIGN](state, data) {
        if (data) {
            state.userCenterSign = data
        }
    },
    [types.SET_USER_PERMISSION](state, data) {
        if (data) {
            state.userPermission = data
        }
    },
    [types.FATHER_TREE_NOTE](state, data) {
        if (data) {
            state.fatherTreeNote = data
        } else {
            state.fatherTreeNote = {}
        }
    },
    [types.SET_WAIT_MEMBER](state, data) {
        if (data) {
            state.waitMemberMap = data
        } else {
            state.waitMemberMap = {}
        }
    },
    [types.LOAD_TREE_TIME](state, data) {
        if (data) {
            state.loadTreeTime += 1
        } else {
            state.loadTreeTime = 0
        }
    },
    [types.VERSION_TREE_MAP](state, data) {
        if (data) {
            state.versionTreeMap = data
        } else {
            state.versionTreeMap = {}
        }
    },
    [types.PUSH_IMAGE_LIST](state, data) {
        if (data) {
            state.imageUrlList = data
        }
    },
};

const actions = {
    setUser: ({ commit }, user) => {
        commit(types.SET_USER, user);
    },
    setUserProfile: ({ commit }, data) => {
        commit(types.SET_USER_PROFILE, data);
    },
    setTargetUser: ({ commit }, targetUser) => {
        commit(types.SET_TARGET_USER, targetUser);
    },
    setCurrentChat: ({ commit }, chatInfo) => {
        commit(types.SET_CURRENT_CHAT, chatInfo);
    },
    setCurrentConversation: ({ commit }, conversation) => {
        commit(types.SET_CURRENT_CONV, conversation);
    },
    setCurrentGroupMenber: ({ commit }, menberList) => {
        commit(types.SET_CURRENT_GROUP_MENBER, menberList);
    },
    resetCurrentConversation: ({ commit }) => {
        commit(types.SET_CURRENT_CONV);
    },
    setContactList: ({ commit }, contactList) => {
        commit(types.SET_CONTACT_LIST, contactList);
    },
    setFriendGroup: ({ commit }, friendGroup) => {
        commit(types.SET_FRIEND_GROUP, friendGroup);
    },
    setContactBook: ({ commit }, contactBook) => {
        commit(types.SET_CONTACT_BOOK, contactBook);
    },
    setGroupList: ({ commit }, groupList) => {
        commit(types.SET_GROUP_LIST, groupList);
    },
    setContactMap: ({ commit }, contactMap) => {
        commit(types.SET_CONTACT_MAP, contactMap);
    },
    setConversationList: ({ commit }, conversation) => {
        commit(types.SET_CONV_LIST, conversation);
    },
    resetConversationList: ({ commit }) => {
        commit(types.RESET_CONV_LIST);
    },
    showMessage: ({ commit }, options) => {
        commit(types.SHOW_MESSAGE, options);
    },
    pushCurrentMessageList: ({ commit }, data) => {
        commit(types.PUSH_CURRENT_MESSAGE_LIST, data);
    },
    getMessageList: ({ commit }, conversationID) => {
        commit(types.GET_MESSAGE_LIST, conversationID);
    },
    clearCurrentUnread: ({ commit }, conversationID) => {
        commit(types.CLEAR_CURRENT_UNREAD, conversationID);
    },
    pushAdminNotice: ({ commit }, data) => {
        commit(types.PUSH_ADMIN_NOTICE, data);
    },
    pushHandLianAppy: ({ commit }, data) => {
        commit(types.PUSH_HAND_APPLY, data);
    },
    deleteHandLianAppy: ({ commit }, applyID) => {
        commit(types.DELETE_HAND_APPLY, applyID);
    },
    pushCopyTreeApply: ({ commit }, data) => {
        commit(types.PUSH_COPY_APPLY, data);
    },
    deleteCopyTreeApply: ({ commit }, applyID) => {
        commit(types.DELETE_COPY_APPLY, applyID);
    },
    pushCommentList: ({ commit }, data) => {
        commit(types.PUSH_COMMENT_LIST, data);
    },
    pushPhotoList: ({ commit }, data) => {
        commit(types.PUSH_PHOTO_LIST, data);
    },
    setCompanyInfo: ({ commit }, data) => {
        commit(types.SET_COMPANY_INFO, data);
    },
    setUserCenterSign: ({ commit }, data) => {
        commit(types.USER_CENTER_SIGN, data);
    },
    setUserPermission: ({ commit }, data) => {
        commit(types.SET_USER_PERMISSION, data);
    },
    setTreeNote: ({ commit }, data) => {
        commit(types.FATHER_TREE_NOTE, data);
    },
    setWaitMember: ({ commit }, data) => {
        commit(types.SET_WAIT_MEMBER, data);
    },
    setLoadTreeTime: ({ commit }, data) => {
        commit(types.LOAD_TREE_TIME, data);
    },
    setVersionTreeMap: ({ commit }, data) => {
        commit(types.VERSION_TREE_MAP, data);
    },
    pushImageList: ({ commit }, data) => {
        commit(types.PUSH_IMAGE_LIST, data);
    },
};

const feedType = {
    'ARTICLE': 1,
    'ALBUM': 2,
    'AUDIO': 3,
    'VIDEO': 4,
    'IMAGE_AD': 5,
    'VIDEO_AD': 6,
};

const authorType = {
    'COM_USER': 1,
    'ADMIN': 2,
};

Vue.prototype.FEED_TYPES = feedType;
Vue.prototype.AUTHOR_TYPES = authorType;

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});
